import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import { useAuth } from '../context/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireParent?: boolean; // If true, only parents can access
  requireKid?: boolean;    // If true, only kids can access
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requireParent, requireKid }) => {
  const { loading, parent, currentKid, userType } = useAuth();
  const location = useLocation();

  // Show loading spinner while checking auth
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '80vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  // If requireParent is set, only allow parents
  if (requireParent && userType !== 'parent') {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If requireKid is set, only allow kids
  if (requireKid && userType !== 'kid') {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If not authenticated at all, redirect to login
  if (!parent && !currentKid) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;